/**
 * Response from GET web/v1/templates/assets/{id} (get one asset template).
 * Use imageId to fetch the template image via GET web/v1/images/{imageId}.
 */
export default interface AssetTemplateReadDto {
  id: string;
  name: string;
  description: string;
  imageId: string;
  isGreasePumpConnectivityEnabled: boolean;
  groups: Groups[];
  endpoints: Endpoints[];
  gateways: Gateways[];
  greasePumps?: GreasePump[];
  type?: string;
  siteId?: string;
  accountName?: string;
}

/** Template administration only (create/edit template). Assets keep using isEnabled. */
export type GroupStatus = 'Active' | 'Inactive' | 'Deleted';

export interface Groups {
  id: string,
  name: string,
  parentId: string,
  imageId: string,
  xPos: number,
  yPos: number,
  isEnabled: boolean,
  /** Template admin only. Not used in assets. */
  status?: GroupStatus,
  attachmentImageIds: string[]
}

/** Template administration only (create/edit template). Assets keep using isEnabled. */
export type EndpointStatus = 'Active' | 'Inactive' | 'Deleted';

export interface Endpoints {
  groupId: string,
  greasePumpId: string,
  id: string,
  name: string,
  pointId?: number,
  endpointDeviceId: string,
  endpointDeviceSerialNumber: string,
  requirementId: string,
  requirementName: string,
  xPos: number,
  yPos: number,
  isEnabled: boolean,
  /** Template admin only. Not used in assets. */
  status?: EndpointStatus,
}

/** Template administration only (create/edit template). */
export type GatewayStatus = 'Active' | 'Inactive' | 'Deleted';

export interface Gateways {
  id: string;
  gatewayId: string;
  name: string;
  serialNumber?: string;
  xPos: number;
  yPos: number;
  /** Template admin only. */
  status?: GatewayStatus;
}

/** Convert asset dialog selection (id + serialNumber + optional name) to full Gateways shape. */
export function gatewayFromSelection(selected: { id: string; serialNumber: string; name?: string }): Gateways {
  return {
    id: selected.id || '',
    gatewayId: '1',
    name: selected.name || '',
    serialNumber: selected.serialNumber || '',
    xPos: 0,
    yPos: 0,
    status: 'Active'
  };
}

/** Template administration only (create/edit template). Assets keep using isEnabled. */
export type GreasePumpStatus = 'Active' | 'Inactive' | 'Deleted';

export interface GreasePump {
  id: string,
  name: string,
  deviceId: string,
  serialNo: string,
  channelNo: number,
  xPos: number,
  yPos: number,
  timingOffsetSeconds?: number,
  isEnabled?: boolean,
  /** Template admin only. Not used in assets. */
  status?: GreasePumpStatus,
  devices: any[]
}
  